import Vue from 'vue';
import Vuex from 'vuex';
import researchStore from '@/store-modules/research-store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {

  },
  actions: {

  },
  modules: {
    researchStore,
  },
});
